<template>
  <div class="">
    <Modal
      v-model="sMessageListModal"
            width="600"
            :title="sMessageTitle"
            :mask-closable="false"
            :loading="loading"
            @on-ok="sMessageList('sMessageListForm')"
        >
      <Form
        ref="sMessageListForm"
        :model="sMessageListForm"
        :rules="ruleValidate"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="CorpID"
          prop="corpid"
          label-for="corpid"
        >
          <Input
            disabled
            placeholder="请输入CorpID"
            element-id="corpid"
            v-model="sMessageListForm.corpid"
          >
            
          </Input>  
        </FormItem>
        <FormItem label="充值短信数量"
          prop="num"
          label-for="num"
        >
          <Input
            placeholder="请输入充值短信数量"
            element-id="num"
            v-model="sMessageListForm.num"
          >
            
          </Input>  
        </FormItem>
        <FormItem label="充值金额"
          prop="amount"
          label-for="amount"
        >
          <Input
            placeholder="请输入充值金额"
            element-id="amount"
            v-model="sMessageListForm.amount"
          >
            
          </Input>  
        </FormItem>
        <FormItem label="充值备注"
          prop="remark"
          label-for="remark"
        >
          <Input 
            placeholder="请输入充值备注"
            element-id="remark"
            v-model="sMessageListForm.remark" 
            type="textarea" 
            :autosize="{minRows: 2,maxRows: 5}" 
          >
          
          </Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    agentId: {
      type: Number
    },
    sMessageTitle: {
      type: String
    },
    sMessageModal: {
      type: Boolean,
      required: true
    },
    sMessageRow: {
      type: Object
    }
  },
  data () {
    const validateNumber = (rule, value, callback) => {
      if (!value.match(/^\d+$/)) {
        callback(new Error('只能输入数字'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      visible: false,
      sMessageListModal: this.sMessageModal,
      sMessageListForm: {
        corpid: '',
        epId: '',
        num: '',
        amount: '',
        remark: ''
      },
      ruleValidate: {
        corpid: [
        { required: true, message: 'corpid不能为空', trigger: 'blur' }
        ],
        num: [
        { required: true, message: '充值短信数量不能为空', trigger: 'blur' },
        { validator: validateNumber, trigger: 'blur' }
        ],
        amount: [
        { required: true, message: '充值金额不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
   // 保存编辑数据
    sMessageList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.sMessageListForm
          }
          let url = '/enterprise/mgr/addSmsNum'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              let msg = '编辑成功'
              this.$Message.success(msg)
              this.sMessageListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.agentId = this.sMessageRow.id
      this.sMessageListForm.epId = this.sMessageRow.id
      this.sMessageListForm.corpid = this.sMessageRow.corpid
    }
  },
  watch: {
    sMessageModal (val) {
      this.sMessageListModal = val
      if (val) {
        this.reload()
      }
    },
    sMessageListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/ShortMessageRecharge.vue